/** A protocol's types as one bar, a segment per stage, so a long list can be scanned for what needs doing. */

import { cn } from '@/lib/utils';
import { countOf, STAGE_LABELS, STAGE_ORDER } from './stage';
import type { ProtocolRollup, TypePromotionStage } from './types';

const SEGMENT_CLASSES: Record<TypePromotionStage, string> = {
	promoted: 'bg-ink',
	templated: 'bg-blue-600',
	ready: 'bg-green-600',
	stale: 'bg-amber-500',
	not_ready: 'bg-red-600',
	untested: 'bg-gray-400'
};

export const RollupBar = ({ rollup, className }: { rollup: ProtocolRollup; className?: string }) => {
	if (!rollup.types) return <div className={cn('h-1.5 rounded-full bg-gray-300', className)} aria-hidden />;
	return (
		<div
			className={cn('flex h-1.5 overflow-hidden rounded-full bg-gray-300', className)}
			role='img'
			aria-label={STAGE_ORDER.filter((stage) => countOf(rollup, stage) > 0)
				.map((stage) => `${countOf(rollup, stage)} ${STAGE_LABELS[stage].toLowerCase()}`)
				.join(', ')}
		>
			{STAGE_ORDER.map((stage) => {
				const count = countOf(rollup, stage);
				return count > 0 ? (
					<span key={stage} className={SEGMENT_CLASSES[stage]} style={{ width: `${(count / rollup.types) * 100}%` }} />
				) : null;
			})}
		</div>
	);
};
